export default __webpack_public_path__ + "static/media/inter-semibold.5a87f7c4.woff";